import { Directive, inject, HostListener } from '@angular/core';
import { ModalService } from '@core/services';
import { DropdownManagerService } from '@shared/services/dropdown-manager.service';

@Directive()
export abstract class ModalDirective {
  protected readonly modalService = inject(ModalService);
  protected readonly dropdownManagerService = inject(DropdownManagerService);

  @HostListener('document:keydown.escape', ['$event'])
  onEscapeButtonPressed(event: KeyboardEvent): void {
    if (this.isAnyDropdownOpen()) {
      event.stopPropagation();
      event.preventDefault();
      this.closeAllDropdowns();
    } else {
      this.close();
    }
  }

  private isAnyDropdownOpen(): boolean {
    return this.dropdownManagerService.isAnyDropdownOpen();
  }

  private closeAllDropdowns(): void {
    this.dropdownManagerService.closeAllDropdowns();
  }

  cancel() {
    this.close();
  }

  close() {
    this.modalService.close();
  }
}
